<template>
  <div class="beast-login-warp register">
    <img v-if="showClose"  class="close" @click="close" src="./assets/close.png">
    <div class="login-head">
      <img src="https://img.thebeastshop.com/static/login/login-logo.png" />>
      <p class="title" >注册成为野兽派新会员</p>
    </div>

    <div class="login-main">
      <div class="input-warp">
        <div class="input-group" >
          <div>
            <div class="input-row" @click="selectCountry">
              <div class="phone-area">
                {{ country.country_code }}
              </div>
              <div class="phone-select">
                {{ country.country_name_cn }}
              </div>
            </div>
            <div class="input-row">
              <input type="text" v-model="mobile" placeholder="请输入手机号">
            </div>
            <div class="input-row" >
              <div class="phone-code">
                <input type="text" v-model="captchaCode" placeholder="请输入图形验证码">
              </div>
              <div class="phone-code-img" @click="changeCode">
                <img :src="captchaCodeSrc">
              </div>
            </div>
            <div class="input-row" >
              <div class="phone-code">
                <input type="text" v-model="mobileCode" placeholder="请输入短信验证码">
              </div>
              <div class="phone-code-text" @click="sendCode">
                {{ phone_code_text }}
              </div>
            </div>
            <div class="input-row">
              <input type="password" v-model="password"  placeholder="请输入密码">
              <i class="icon show-password"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-tips">
      <span class="error">{{ error }}</span>
    </div>
    <div @click="register" class="login-btn">
      注册
    </div>
    <div @click="login" class="to-login">
      已经是会员？去登录>
    </div>
     <register-success :successShow="successShow" @cancel="success"></register-success>
  </div>
</template>

<script>
import track from '@/track'
import _country from './data/country.js'
import Vue from 'vue'
import Select from '@/plugins/select'
import RegisterSuccess from './register-success.vue'
import api from './api.js'
let _countDown = null
Vue.use(Select)
export default {
  components:{
    RegisterSuccess
  },
 data (){
   return {
    countryIndex: 0,
    error: '',
    mobile: '',
    codeEnd: 0,
    captchaCode: '',
    mobileCode: '',
    password: '',
    showPassword: false,
    codeTime: new Date().getTime(),
    successShow: false
   }
 },
 props: {
  showClose: {
    default: true
  }
 },
 computed: {
   country: function(){
     return _country[this.countryIndex]
   },
   phone_code_text: function(){
    return this.codeEnd === 0
      ? '获取验证码'
      : `重新获取(${this.codeEnd})`
   },
   captchaCodeSrc: function(){
    return `${process.env.AXIOS_BASE_URL}/app/captcha?_timestamp=${this.codeTime}`
   }
 },
 methods: {
  changeCode: function(){
    this.codeTime = new Date().getTime()
  },
  countDown: function(){
    if (this.codeEnd === 0) {
      clearTimeout(_countDown)
    }else{
      this.codeEnd--
      var that = this
      _countDown = setTimeout(function() {
        that.countDown()
      }, 1000)
    }
  },
  sendCode: function(){
    track({
      name: 'verificationCode'
    })
    if(this.codeEnd > 0){
      return false
    }
    if(this.mobile.length!=11){
      this.$alert("请输入正确的手机号")
      return
    }
    if(this.captchaCode == ''){
      this.$alert("请输入图形验证码")
      return
    }
    sa.track('GetCode', {
      service_type: '快捷登录注册'
    })
    api.sms(this.mobile, this.captchaCode)
    .then((data) => {
      this.codeEnd = 60
      this.countDown()
    })
    .catch(({code , message}) => {
      // this.$alert(message)
    })
  },
  selectCountry: function(){
    track({
      name: 'areaCode'
    })
    this.$select(_country.map((item) => {
      return item.country_name_cn
    }))
    .then((data) => {
      this.countryIndex = data
    })
    .catch(()=>{
      // console.log('select-cancel');
    })
  },
  close: function (){
    track({
      name: 'close'
    })
    this.clean()
    this.$emit('cancel')
  },
  login: function (){
    track({
      name: 'register-login'
    })
    this.clean()
    this.$emit('login')
  },
  success: function(){
    this.successShow = false
    this.clean()
    this.$emit('register')
  },
  clean: function (){
    this.error = ''
    this.mobile = ''
    this.codeEnd = 0
    clearTimeout(_countDown)
    this.captchaCode = ''
    this.mobileCode =  ''
    this.password =  ''
    this.showPassword = false
    this.successShow = false
  },
  register: function(){
    track({
      name: 'register-register'
    })
    // this.successShow = true
    if(this.mobile.length!=11){
      this.$alert("请输入正确的手机号")
      return
    }
    if(this.mobileCode == ''){
      this.$alert("请输入短信验证码")
      return
    }
    const password_reg = /^[a-z0-9]{6,16}$/i
    if(!password_reg.test(this.password)){
      this.$alert("密码必须为6-16位数字或字母")
      return
    }
    api.register(this.mobile, this.password, this.mobileCode)
    .then((data) => {
      this.successShow = true
      this.$alert(`注册成功`)
      .then(() => {
        this.$emit('register')
      })

    })
    .catch(({code , message}) => {
      track({
        name: 'register-failed',
        attrs: {
          message
        }
      })
      this.$alert(message)
    })
  }
 }
}
</script>

<style lang="stylus">
@import './index.styl'

</style>



// WEBPACK FOOTER //
// register.vue?6186c183